/**
 * Created by Babu on 16/5/11.
 */

var React = require('react');

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, EventConstants} = require("../Constants");

var ReactDOM = require("react-dom");

module.exports = React.createClass({
    displayName: "PowerList",

    getInitialState(){
        var hash = window.location.search;
        var firstPage = hash ? null : this.props.firstPage;
        return {
            powerListData: firstPage
        }
    },

    componentWillMount(){

        ALikeStore.on(EventConstants.AJAX_SEARCH_POWER_LIST_COMPLETE, this.on_searchPowerListComplete);
        ALikeStore.on(EventConstants.AJAX_LOAD_POWER_LIST_COMPLETE, this.on_loadPowerListComplete);
    },
    componentWillUnmount(){

        ALikeStore.off(EventConstants.AJAX_SEARCH_POWER_LIST_COMPLETE, this.on_searchPowerListComplete);
        ALikeStore.off(EventConstants.AJAX_LOAD_POWER_LIST_COMPLETE, this.on_loadPowerListComplete);
    },

    componentDidUpdate(){
        this._renderExtend();
    },
    _renderExtend(){
        var node = ReactDOM.findDOMNode(this);

        var item = $(node).find(".item").eq(0);
        var recommend = item.data("recommend") || 0;

        var recommendObj = $(".reg-super-list > .mod-super-recommend");
        if(+recommend){
            if(recommendObj.length ==0){
                $(node).find(".mod-super-recommend").removeClass("hide");
            }
        }else{
            recommendObj.remove();
            $(node).find(".mod-super-recommend").addClass("hide");
        }

        var listtTitle = $(node).find(".mod-super-list-title");
        var walleHasStartFalg = 0;
        if(listtTitle.length>0){
            walleHasStartFalg = 1;
        }
        Dispatcher.dispatch({type: ActionConstants.WALLE_HAS_START_FLAG, data: walleHasStartFalg});

    },
    /**
     * 选择器查询结果
     */
    on_searchPowerListComplete(){
        var powerList = ALikeStore.get_powerList();
        this.setState({powerListData: powerList});
    },
    /**
     * 向下滚动查询
     */
    on_loadPowerListComplete(){
        var powerList = ALikeStore.get_powerList();
        this.setState({powerListData: powerList});
    },
    render(){
        var powerLists = this.state.powerListData;
        var listItems = _.map(powerLists, function (item, index) {
            return (
                <div key={index} dangerouslySetInnerHTML={{__html: item}}></div>
            );
        });
        return (
            <div>
                <div className="mod-super-recommend hide">
                    <div className="recommend-super-txt">
                        <i className="icon-power-list-filter-noresult-new"></i>
                        <span>暂未找到 <br/> 筛选的线路<br/>为您推荐相似线路</span>
                    </div>
                </div>

                {listItems}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./script/list-m/PowerList.jsx
 **/